export default function luhn(n) {
  const result = n.split('').reverse().reduce((sum, digit, i) => {
    let d = parseInt(digit, 10);
    if (i % 2 !== 0) {
      d *= 2;
      if (d > 9) {
        d -= 9;
      }
    }
    return sum + d;
  }, 0);

  return result % 10 === 0;
}



/** WEBPACK FOOTER **
 ** ./shared/luhn.js
 **/